import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import CollapsibleContainer from "components/react-lib/generic-ui/CollapsibleContainer";
import HeaderCell from "components/table/HeaderCell";
import React from "react";

export default function Costs({ pricing }) {
  const formatPrice = (price) => {
    return `${price.toFixed(6)} $`;
  };

  return (
    <CollapsibleContainer title={"Variable costs"} titleVariant="subtitle">
      <Table size="small">
        <TableBody>
          <TableRow>
            <HeaderCell align="left">
              Text to audio cost per character
            </HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.audio.costPerCharacter)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">Audio to text cost per second</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.audio.costPerSecond)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">Cost per page</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.ocr.costPerPage)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </CollapsibleContainer>
  );
}
